import { api } from './client';
import type { Advocate, Role } from './types';

export function listAdvocates(includeFrozen = false): Promise<{ advocates: Advocate[] }> {
  return api.get(`/api/v1/advocates${includeFrozen ? '?includeFrozen=1' : ''}`);
}

export function getAdvocate(id: number): Promise<{ advocate: Advocate }> {
  return api.get(`/api/v1/advocates/${id}`);
}

export function createAdvocate(body: Record<string, any>): Promise<{ advocate: Advocate }> {
  return api.post(`/api/v1/advocates`, body);
}

export function updateAdvocate(id: number, body: Record<string, any>): Promise<{ advocate: Advocate }> {
  return api.put(`/api/v1/advocates/${id}`, body);
}

export function listRoles(): Promise<{ roles: Role[] }> {
  return api.get(`/api/v1/roles`);
}
